import React, { useEffect, useState } from "react";
import { axiosPrivate } from "../../api/axios";
import { GET_FILE } from "../../api/apiClient";
import Lottie from "react-lottie";
import animationData from "../../jsons/ddddot.json";

interface ImageDisplayProps {
  access_token: string;
  imageUID: string;
}

const LogoComponent: React.FC<ImageDisplayProps> = ({
  imageUID,
  access_token,
}) => {
  const [base64Image, setBase64Image] = useState<any>(undefined);
  const [isLoading, setIsLoading] = useState<any>(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  const fetchImage = async () => {
    setIsLoading(true);
    try {
      const response = await axiosPrivate.get(GET_FILE(imageUID), {
        headers: {
          accept: "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },

        withCredentials: true,
      });
      if (response?.status >= 200 && response.status < 300) {
        setBase64Image(response?.data?.data?.url);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching image data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchImage();
  }, [imageUID]);

  return (
    <div className="w-8 h-8">
      {isLoading ? (
        <Lottie options={defaultOptions} height={20} />
      ) : (
        <img
          src={base64Image}
          alt="description"
          className="rounded-full h-full w-full object-cover"
        />
      )}
    </div>
  );
};

export default LogoComponent;
